import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/fms/fms_vehicle_types`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_vehicle_types/${id}`, options)
    .then(response => {
      let vehicles = jsona.deserialize(response.data);
      delete vehicles.links;
      return vehicles;
    });
}

function add(vehicles) {
  
  console.log(vehicles);
  const payload = jsona.serialize({
    stuff: vehicles,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/fms/fms_vehicle_types`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(vehicles) {
  const payload = jsona.serialize({
    stuff: vehicles,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/fms/fms_vehicle_types/${vehicles.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/fms/fms_vehicle_types/${id}`, options);
}

function listByBrand(brand) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_vehicle_types?filter[vehicle_brand_id]=${brand}`, options)
    .then(response => {
      let vehicles = jsona.deserialize(response.data);
      delete vehicles.links;
      return vehicles;
    });
}

function last_no() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_vehicle_types/last/no`, options)
    .then(response => {
      return response.data;
    });
}




export default {
  list,
  get,
  add,
  update,
  listByBrand,
  destroy,
  last_no
};

